import { useState, useEffect, useMemo } from "react";
import { Box, Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import AlertDialogBox from "../../common/Components/AlertDialogBox";
import ViewAllAlerts from "../../common/Components/ViewAllAlerts";
import PowerBIReportEmbed from "../PowerBIReportEmbed";
import { setPowerBiData, TabNameChange } from "../../store/Actions";
import KPIService from "../../services/console_services/KPI";
import MapService from "../../services/console_services/Map";
import { setViewPowerBi } from "../../store/Actions";
import useTabList from "../../common/TabList";
import UserDetailsServices from "../../services/console_services/LoginLogot";
import TabComponent from "../../common/Components/TabComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));

const F_Forecast = ({
  tabIndex,
  Network,
  DC,
  Products,
  date,
  applyFilter,
  Division,
  PL3,
  periodType,
  role,
  viewPowerBi,
  setViewPowerBi,
  Temperature,
  Facility,
  FacilityType,
  location,
  fromState,
  toState,
  fromZip,
  toZip,
  lane,
  dateRangeDetention,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [viewAll, setViewAll] = useState(false);
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const dispatch = useDispatch();
  const TabList = useTabList();
  const currentTabData = useMemo(() => TabList["FF"][tabIndex], [tabIndex]);
  console.log("tablisttttttttttttttt", TabList, currentTabData, tabIndex);
  const reduxState = useSelector((state) => state);
  const [kpiPowerBi, setKpiPowerBI] = useState("");

  useEffect(() => {
    dispatch(TabNameChange(currentTabData.value));
    const fetchMapData = async () => {
      const params = {
        name: currentTabData.value,
        Level: role,
        filter: {
          Network,
          temperature: Temperature,
          Facility: Facility,
          FacilityType: FacilityType,
          Spend_Location_Type: location,
          Division: Division,
          Source_State: fromState,
          Destination_State: toState,
          Source_3zip: fromZip,
          Destination_3zip: toZip,
          lane: lane,
          startDate:
            reduxState?.tabs?.tabName === "DETENTION"
              ? dateRangeDetention[0]
              : date[0],
          endDate:
            reduxState?.tabs?.tabName === "DETENTION"
              ? dateRangeDetention[1]
              : date[1],
        },
      };

      setMapLoading(true);
      MapService.getMAP(params, instance)
        .then((data) => {
          if (data?.data) {
            setMapData(data?.data);
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => setMapLoading(false));
    };
    fetchCreateAlertsWithUser();
    fetchMapData();
  }, [
    tabIndex,
    role,
    applyFilter,
    DC,
    Network,
    PL3,
    Division,
    Products,
    date,
    dateRangeDetention,
  ]);
  // let reduxTab = reduxState?.tabs?.tabName;

  // let moduleType;
  // switch (reduxTab) {
  //   case "FF":
  //     moduleType = "FF";
  //     break;
  //   case "DETENTION":
  //     moduleType = "DETENTION";
  //     break;
  //   // default:
  //   //   moduleType = undefined; // or a default
  // }

  const fetchCreateAlertsWithUser = () => {
    if (currentTabData?.value) {
      UserDetailsServices.createAlertsWithUser(
        {
          module: currentTabData?.value,
        },
        instance,
      );
      UserDetailsServices.createAlertsWithThresholdUser(
        {
          module: currentTabData?.value,
        },
        instance,
      );
    }
  };

  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData.value,
        periodType,
        Level: role,
        filter: {
          Network,
          temperature: Temperature,
          Facility: Facility,
          FacilityType: FacilityType,
          Spend_Location_Type: location,
          Source_State: fromState,
          Destination_State: toState,
          Source_3zip: fromZip,
          Destination_3zip: toZip,
          lane: lane,
        },
      };
      setKPILoading(true);
      KPIService.getKPI(params, instance)
        .then((data) => {
          if (data?.response) {
            setKPIData(data?.response);
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => setKPILoading(false));
    };
    if (
      ((currentTabData.value === "DETENTION" ||
        currentTabData.value === "TM") &&
        periodType === "MOM") ||
      (currentTabData.value === "FF" &&
        (periodType === "MOM" || periodType === "WOW"))
    ) {
      fetchKPIData();
    }
  }, [
    tabIndex,
    periodType,
    role,
    applyFilter,
    DC,
    Network,
    Temperature,
    Facility,
    FacilityType,
    location,
    Division,
    fromState,
    toState,
    fromZip,
    toZip,
    lane,
  ]);

  const toggleViewAll = () => setViewAll(!viewAll);

  const toggleViewPowerBi = (val) => {
    setKpiPowerBI(val);
    setViewPowerBi(!viewPowerBi);
    dispatch(setPowerBiData(val));
  };

  return (
    <Box className={classes.root}>
      {viewPowerBi ? (
        <PowerBIReportEmbed selectedPowerData={kpiPowerBi} />
      ) : (
        <>
          {!viewAll ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <TabComponent
                  KPIData={KPIData}
                  mapData={mapData}
                  tabList={TabList["FF"]}
                  MapLoading={MapLoading}
                  KPILoading={KPILoading}
                  Module={currentTabData.value}
                  handleViewPowerBi={toggleViewPowerBi}
                  graphViewTabList={TabList["FF"][tabIndex].graphViewTabList}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                className={classes.gridItem}
                sx={{ mt: "93px" }}
              >
                <AlertDialogBox
                  handleViewAll={toggleViewAll}
                  handleViewPowerBi={toggleViewPowerBi}
                  viewAll={viewAll}
                />
              </Grid>
            </Grid>
          ) : (
            <ViewAllAlerts viewAll={viewAll} handleClose={toggleViewAll} />
          )}
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
  // Products: state.filter.Products,
  Temperature: state.filter.Temperature,
  Facility: state.filter.facId,
  FacilityType: state.filter.facType,
  location: state.filter.location,
  fromState: state.filter.fromState,
  toState: state.filter.toState,
  fromZip: state.filter.fromZip,
  toZip: state.filter.toZip,
  lane: state.filter.lane,
  dateRangeDetention: state.filter.dateRangeDetention,
});

const mapDispatchToProps = {
  setViewPowerBi,
};

export default connect(mapStateToProps, mapDispatchToProps)(F_Forecast);
